document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('#load-more-news');
  const newsList = document.querySelector('#news-list');

  if (!button || !newsList || typeof tribuNews === 'undefined') return;

  button.addEventListener('click', async () => {
    const category = button.dataset.category;
    const postType = button.dataset.posttype ?? 'post';
    const offset = parseInt(button.dataset.offset, 10);
    const step = parseInt(button.dataset.step, 10);
    const pageSlug = new URL(window.location.href).pathname.match(/[^\/]+/g);

    button.disabled = true;
    button.textContent = 'Chargement...';

    try {
      const formData = new FormData();
      formData.append('action', 'tribu_load_more_news');
      formData.append('post_type', postType);
      formData.append('nonce', tribuNews.nonce);
      formData.append('category', category);
      formData.append('offset', offset);
      formData.append('step', step);
      if (pageSlug === 'archive-evenements') {
        formData.append('date', 'inf');
      } else {
        formData.append('date', 'sup');
      }

      const response = await fetch(tribuNews.ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.data || 'Erreur AJAX');
      }

      newsList.insertAdjacentHTML('beforeend', data.data.html);

      button.dataset.offset = offset + step;

      if (!data.data.has_more) {
        button.remove();
      } else {
        button.disabled = false;
        button.textContent = "Afficher plus d'actualités";
      }
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = "Afficher plus d'actualités";
    }
  });
});
